export type VectorStoreProvider = "azure" | "milvus";

export const availableVectorStoreProviders = ["azure", "milvus"] as const;